<template>
	<div v-if="profileNotFound" class="center-container">
		<h1>Profile not found</h1>
		<p>Sorry, but there is no person with that ID in our database. If this problem persists, contact <a href="mailto:support@bookplate.co">support@bookplate.co</a>.</p>
		<h2><router-link to='/'>Return Home</router-link></h2>
	</div>
	<div v-else>
		<div class="center-container">
			<h2>
				<router-link :to="{path:'/profile/' + readerId}" class="profile" v-bind:style="'background:' + readerProfileColour">profile</router-link>
				{{ readerName }}
			</h2>
			<h6 v-if="favouriteBook != '' && favouriteBook != 'undefined' && favouriteBook != null">
				<svg style="transform:translateY(4px); margin-right: 1ch;" xmlns="http://www.w3.org/2000/svg" width="21.953" height="16"><path fill="var(--grey-40)" d="M11.358 16.001V2.661a4.2 4.2 0 0 1 2.24-1.937 8.54 8.54 0 0 1 3.263-.6 8.581 8.581 0 0 1 3.523.7c1.014.477 1.569 1.143 1.569 1.877l-.024 13.294c0-.716-.546-1.364-1.539-1.824a8.587 8.587 0 0 0-3.469-.671 8.807 8.807 0 0 0-3.3.593 4.282 4.282 0 0 0-2.263 1.908zm-.769-.036a4.575 4.575 0 0 0-2.366-2.051 8.846 8.846 0 0 0-3.415-.658 7.4 7.4 0 0 0-3.338.706 2.354 2.354 0 0 0-1.472 1.963L.023 2.701A2.307 2.307 0 0 1 1.537.713 7.787 7.787 0 0 1 4.963.001c2.079 0 4.649.694 5.626 2.641v13.322z"/></svg>
				<router-link :to="{path:'/book/' + favouriteBook.book_id}" >{{ favouriteBook.title }}</router-link>
			</h6>
			<h6 v-else>&nbsp;</h6>
			<div class="content-buttons">
				<button v-if="this.$route.params.id == $store.getters.userId">Edit Profile</button>
				<button v-if="this.$route.params.id == $store.getters.userId" id="log-out-btn" v-on:click="logout()">Log Out</button>
				<button v-else-if="status == ''" v-on:click="friendOperation()">Add Friend</button>
				<button v-else :class="(status == 'Pending' || status == 'Remove Friend' || status == 'Unblock') ? 'selected' : ''" id="friend-btn" v-on:click="friendOperation()">{{ status }}</button>
				<button v-if="status == 'Accept Friend'" id="decline-btn" v-on:click="removeFriend()">Decline</button>
			</div>
		</div>
		<nav class="profile-nav">
			<router-link v-if="this.$route.params.id == $store.getters.userId" :to="{path:'/profile/' + readerId + '/library'}">Your Library</router-link>
			<router-link v-else :to="{path:'/profile/' + readerId + '/library'}">{{ pronoun }} Library</router-link>
			<router-link :to="{path:'/profile/' + readerId + '/liked'}">Liked Books</router-link>
			<router-link :to="{path:'/profile/' + readerId + '/read'}">Read Books</router-link>
			<router-link :to="{path:'/profile/' + readerId + '/to-read'}">To-Read List</router-link>
			<router-link :to="{path:'/profile/' + readerId + '/friends'}">Friends</router-link>
		</nav>
		<mini-list v-bind:title="'Recent Likes'">
			<router-link v-for="likedBook in likedBooks" :key="likedBook.title" class="cover" :to="{path:'/book/' + likedBook.book_id}" v-bind:style="{ backgroundImage: 'url(' + likedBook.cover_url + ')' }">"{{ likedBook.title }}" book cover</router-link>
		</mini-list>
	</div>
</template>

<script>
	import MiniList from '../layout/MiniList.vue'

	export default 
	{
		components: 
		{
			MiniList
		},
		data ()
		{
			return {
				info: "",
				notFound: false,
				status: "" 
			}
		},
		mounted () 
		{
			try 
			{
				let vue = this;

				fetch('https://api.bookplate.co/profile/' + this.readerId,
				{
					credentials: 'include'
				})
				.then(function(response)
				{
					if(response.status == 404)
					{
						vue.notFound = true;
						return "";
					}

					return response.json();
				})
				.then(json => this.info = json)
				.then(function (json) 
				{
					if(vue.notFound)
					{
						document.title = "Profile not found | Bookplate";
					}
					else
					{
						document.title = json.name + "'s Profile | Bookplate";
					}
				})

				if((!vue.notFound) && (vue.$store.getters.userId != "0") && (vue.$store.getters.userId != this.readerId))
				{
					fetch('https://api.bookplate.co/reader/profile/' + this.readerId, {
						credentials: 'include'
					})
					.then(function(response) {
						if(response.status == 404)
						{
							return "";
						}
						else if(response.status == 401)
						{
							console.log("You must be logged in. (Try refreshing the page)");
							vue.$store.dispatch('saveUserLogged', "0");
							vue.router.replace("/profile/" + vue.$route.params.id + "?=logout");
							return "";
						}
						else if(response.status != 200)
						{
							vue.$alert("Something went wrong. Please try again in a moment, or contact support@bookplate.co.", "Error loading your data (" + response.status + ")");
							return "";
						}

						return response.json();
					})
					.then(function (json) {
						vue.status = json.status
					})
				}
			}
			catch(e)
			{
				this.$alert("Something went wrong. Please try again in a moment, or contact support@bookplate.co. Error:" + e, "An error occured");
			}
		},
		computed: 
		{
			profileNotFound: function()
			{
				return this.notFound;
			},
			readerName: function() 
			{
				return this.info.name;
			},
			pronoun: function()
			{
				return this.info.pronoun;
			},
			readerId: function() 
			{
				return this.$route.params.id;
			},
			readerProfileColour: function() 
			{
				return this.info.profile_color;
			},
			favouriteBook: function()
			{
				return this.info.favourite_book;
			},
			likedBooks: function()
			{
				return this.info.liked_books;
			},

		},
		created () 
		{
			document.title = this.readerName + "'s Profile | Bookplate";
		},
		methods:
		{
			logout: function()
			{
				try
				{
					window.navigator.vibrate(30);
				}
				catch(e)
				{
					//pass
				}

				let vue = this;
				const server = new XMLHttpRequest();
				var url = 'https://api.bookplate.co/logout';
				server.open('POST', url, true);
				server.withCredentials = true;
				server.setRequestHeader('Content-type', 'application/json');
				server.getResponseHeader('Set-Cookie');

				server.onreadystatechange = function()
				{
					if(server.readyState == 4) 
					{
						vue.$store.dispatch('saveUserLogged', "0");
					}
				}
				server.send(JSON.stringify(""));
			},
			friendOperation: function()
			{
				if(this.$store.getters.userId == "0")
				{
					this.$alert("You must be logged in. Try refreshing the page or contact support@bookplate.co if the problem persists.", "Not logged in");
					return "";
				}

				switch (this.status) 
				{
					case "Accept Friend":
					case "Add Friend":
						this.addFriend();
						break
					case "Remove Friend":
						this.removeFriend();
						break
					case "Pending":
						this.removeFriend();
						break
					case "Unblock":
						this.unblockReader();
						break
				}

				document.getElementById("friend-btn").blur();
			},
			removeFriend: function()
			{
				try
				{
					window.navigator.vibrate(30);
				}
				catch(e)
				{
					//pass
				}

				const data = {
					headers: 
					{ 
						"content-type": "application/json; charset=UTF-8",
						"accept": "application/text"
					},
					credentials: 'include',
					method: "POST"
				};

				fetch("https://api.bookplate.co/friend/remove/" + this.readerId, data)
				.then(res=>console.log(res))
				.catch(error=>console.log(error));

				this.status = "Add Friend";
			},
			unblockReader: function()
			{
				try
				{
					window.navigator.vibrate(30);
				}
				catch(e)
				{
					//pass
				}

				const data = {
					headers: 
					{ 
						"content-type": "application/json; charset=UTF-8",
						"accept": "application/text"
					},
					credentials: 'include',
					method: "POST"
				};

				fetch("https://api.bookplate.co/friend/add/" + this.readerId, data)
				.then(res=>console.log(res))
				.catch(error=>console.log(error));

				this.status = "Add Friend";
			},
			addFriend: function()
			{
				try
				{
					window.navigator.vibrate(30);
				}
				catch(e)
				{
					//pass
				}

				const data = {
					headers: 
					{ 
						"content-type": "application/json; charset=UTF-8",
						"accept": "application/text"
					},
					credentials: 'include',
					method: "POST"
				};

				fetch("https://api.bookplate.co/friend/add/" + this.readerId, data)
				.then(res=>console.log(res))
				.catch(error=>console.log(error));

				if(this.status == "Accept Friend")
				{
					this.status = "Remove Friend";
				}
				else
				{
					this.status = "Pending";
				}
			}

		}
	}
</script>